/**
@ngdoc service
@name podService

@description
Provides a data sharing service for pod controllers
*/
angular.module('app').service('podService', function($rootScope) {
	var DEBUG = false;
	if(DEBUG) console.log('podService');
	return {

	    pods: [],
        findFreePodPosition: function(maxRows, maxColumns, pod, pods) {
            // Check rows
            for(var row = 0; row < maxRows; row ++) {
                // Check columns
                for(var col = 0; col < maxColumns; col++) {
                    // Validate this position against all current pods
                    var spaceFree = true;
                    for (var i = 0; i < pods.length; i++) {
                        var targetPod = pods[i];
                        // Pod A is the position we are checking + the pods size
                        var podA = { left: col, right: col + pod.sizeX - 1, top: row, bottom: row + pod.sizeY - 1 }
                        // Pod B is the target pods position
                        var podB = { left: targetPod.col, right: targetPod.col + targetPod.sizeX - 1, top: targetPod.row, bottom: targetPod.row + targetPod.sizeY - 1 }

                       // console.log()

                        // Check intersection using row/column for iteration above and height/width from pod
                        if(this.rectanglesIntersect(podA, podB)) {
                           spaceFree = false;
                           console.log("[" + row + "," + col + "] Not Free");
                        }
                    }

                    if(spaceFree) {
                        console.log("Found free space at [" + row + "," + col + "] assigning to pod id " + pod.id);
                        pod.row = row;
                        pod.col = col;

                        return true;
                    }
                }
            }
            return false;
        },
        findMaxRow: function(pods) {
	        var maxRow = 0;
            for (var i = 0; i < pods.length; i++) {
                var pod = pods[i];
	            if(pod.row > maxRow) {
	                maxRow = pod.row;
                }
            }

            return maxRow + 1;
        },
        rectanglesIntersect: function(a, b) {
            return (a.left <= b.right &&
                b.left <= a.right &&
                a.top <= b.bottom &&
                b.top <= a.bottom)
        },

        podsIntersect: function(podA, podB) {

            var rectangleA = this.podToRectangle(podA);
            var rectangleB = this.podToRectangle(podB);

            var intersects = this.rectanglesIntersect(rectangleA,rectangleB);
            return intersects;
        },
        podToRectangle: function(pod) {
            return { left: pod.col, right: pod.col + pod.sizeX - 1, top: pod.row, bottom: pod.row + pod.sizeY - 1 }
        },
        getPodIndex: function(id) {
            // Sometimes we can't use indexOf/remove because we have a different instance
            // so get the index via id
            for (var i = 0; i < this.pods.length; i++) {
                if (this.pods[i].id.toString() === id.toString()) {
                    return i
                }
            }
            return -1
        },
        getPodsInWay: function(pod) {
	        var podsInWay = [];
            for (var i = 0; i < this.pods.length; i++) {
                var targetPod = this.pods[i];
                if(this.podsIntersect(pod,targetPod)) {
                    if(targetPod.id !== pod.id) {
                        podsInWay.push(targetPod);
                    }
                }
            }

            return podsInWay;
        },
        resetPod: function(id,originPod) {
	      this.removePod(id);

	      if(originPod) {
	          // Find out if anything is occupying the origin pods position
	          var podsInWay = this.getPodsInWay(originPod);
	          // Add the origin pod
              this.pods.push(originPod);

              // If there was something in it's position, remove it,
              // find a new position for it.
	          if(podsInWay.length > 0) {
	              var firstInWay = podsInWay[0];

                  var maxRow = this.findMaxRow(this.pods) + 1;
                  if(this.findFreePodPosition(maxRow,4,firstInWay, this.pods)) {
                      $rootScope.$broadcast("pod.position.updated", this.pods);
                  }
              }
          }
        },

        removePod: function(id) {
	        var podIndex = this.getPodIndex(id);
            this.pods.splice(podIndex, 1);
        },
        updateOrAddPod: function(pod, id) {
            var podIndex = this.getPodIndex(id)
            if(podIndex !== -1) {
                // updates or adds properties
                angular.extend(this.pods[podIndex], pod);
            } else {

                var maxRow = this.findMaxRow(this.pods) + 1;
                if(this.findFreePodPosition(maxRow,4,pod, this.pods)) {
                    $rootScope.$broadcast("pod.position.updated", this.pods);
                }
                this.pods.push(pod);
            }
        },
        checkPodConflicts: function (pod, userType, maxHeight) {
            var maxRow = this.findMaxRow(this.pods) + maxHeight;
            var podsInWay = this.getPodsInWay(pod)

            if (podsInWay.length > 0) {
                console.log("There are pods in the way for %s", pod.id)
                //TODO: Does this pod belong to the current user type?
                if (pod.xmsType === userType) {
                    console.log("Attemping to move pod %s from row %s and column %s", pod.id, pod.row,pod.col)
                    // Lets move this pod  to the next free space as it's a user pod
                    if(this.findFreePodPosition(maxRow,4,pod,this.pods)) {
                        console.log("Successfully moved pod %s to row %s and column %s", pod.id, pod.row, pod.col)
                        return true;
                    } else {
                        console.log("Failed to move pod %s", pod.id);
                        return false;
                    }
                }
            }

            return null;
        }
    };
});